import MaterialButton from '@mui/material/Button';

import React from 'react';

import ButtonProgressBar from './ButtonProgressBar';
import styled from 'styled-components';
import { Colors, darken } from '../../utils/style/colors';
import { compose } from 'redux';

class PrimaryButton extends React.PureComponent {

	render() {
		const {classes, align, loading, disabled, children, color, onRef, onClick, ...other} = this.props;
		return (
			<Wrapper {...other} align={align}>
				<MaterialButton
					variant="contained"
					color="primary"
					onClick={e => {
						if(!disabled) {
							onClick(e);
						}
					}}
					ref={r => onRef && onRef(r)}
					disabled={loading || disabled}
					{...other}
				>
					{children}
					{loading && <ButtonProgressBar isVisible={loading}/>}
				</MaterialButton>
			</Wrapper>
		);
	}
}

export default compose(

)(PrimaryButton);


const Wrapper = styled.div`
	display: inline-block;
	position: relative;
	button:hover {
		background-color: ${darken(Colors.primary(), 1.2)};
	}
	${props => props.align === 'left' && `
		button {
			justify-content: flex-start;
		}
	`};
	.progressBar {
		border-bottom-left-radius: 4px;
		border-bottom-right-radius: 4px;
	}
	${props => props.fullWidth && `
		width: 100%;
	`};
`;